export const SectionPostTypes = Object.freeze({
    PETITIONS: 'petitions',
    CROWDPAC: 'crowdpac',
    NEWS: 'news',
    BLOGS: 'blogs',
    LOBBY: 'lobby',
    OPINION: 'opinion',
    POLLS: 'polls',
    POST_SHARED: 'post_shared',
    MEMBER: 'member',
    GROUPS: 'groups',
    GROUP_OPINIONS: 'group-opinions',
    EVENTS: 'events',
    ELECTIONS: 'races',
    CAMPAIGN_UPDATE: 'campaign-updates',
    CANDIDATE: 'candidate',
    LIVESTREAMS: 'livestreams',
    RALLIES: 'rallies',
    CUSTOM_CONTENTS: 'custom-contents',
    OFFICIALS: 'officials',
});

export const ActionTypes = Object.freeze({
    CONTACT_REPS: 'contact_reps',
});
